/// <reference path="appbase.ts" />

namespace TerminalApp {
    class App_Arrival_Create extends AppBase {
        form: HTMLFormElement;
        error: HTMLElement;
        create_arrival_id = document.getElementById("create_arrival_id") as HTMLInputElement;
        create_arrival_customer = document.getElementById("create_arrival_customer") as HTMLSelectElement;
        create_arrival_type = document.getElementById("create_arrival_type") as HTMLSelectElement;
        create_arrival_sender = document.getElementById("create_arrival_sender") as HTMLInputElement;
        create_arrival_reference_no = document.getElementById("create_arrival_reference_no") as HTMLInputElement;
        create_arrival_purchaseorder_id = document.getElementById("create_arrival_purchaseorder_id") as HTMLInputElement;
        create_arrival_submit = document.getElementById("create_arrival_submit");

        constructor() {
            super("app_arrival_create");
            this.form = document.getElementById("arrival_form") as HTMLFormElement;
            this.error = document.getElementById("arrival_form_error");

            document.getElementById("create_arrival_submit").addEventListener("click", () => {
                this.SubmitForm();
            });
        }


        async onOpen() {
            var id = SP.getHash("id");
            var edit = id && id.length;
            //edit
            if (edit) {
                var data = await SP.Data.Arrival.getArrivalInfo(id);
                console.log("Arrival Data:", data);
                this.create_arrival_id.value = data.arrivalId;
                this.create_arrival_customer.value = data.customerId;
                this.create_arrival_type.value = data.arrivalType.toString();
                console.log("setting type dropdown to:", data);
                this.create_arrival_sender.value = data.arrivalSender;
                this.create_arrival_reference_no.value = data.arrivalReferenceNo;
                this.create_arrival_purchaseorder_id.value = data.purchaseOrderInfo?.id ?? "";
            }
            else {
                this.form.reset();
            }

            this.create_arrival_submit.innerHTML = edit ? SP.Localize("sentance_save_changes") : SP.Localize("sentance_create_arrival");
        }




        async SubmitForm() {
            var result = await SP.postForm("/API/FormSubmit/Arrival", "#arrival_form");

            if (result.status == 200) {
                SP.Sounds.Success.play();
                GetApp("app_arrival").open();
                this.form.reset();
                this.error.style.display = "none";

            }
            else {
                SP.Sounds.Error.play();
                this.error.innerHTML = result.msg;
                this.error.style.display = "block";
                console.log(result);
            }
        }
    }
    RegisterApp("app_arrival_create", App_Arrival_Create);
}